import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-thin-right",
  "use": "icon-thin-right-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1000 1000\" id=\"icon-thin-right\">\n<metadata>IcoFont Icons</metadata>\n<title>thin-right</title>\n<glyph glyph-name=\"thin-right\" unicode=\"&#xeaca;\" horiz-adv-x=\"1000\"></glyph>\n<path d=\"M337.6 783.6l291.9-283.6-292-283.6 16-16.399999999999977 308.9 300-308.79999999999995 300-16-16.399999999999977z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol